<template>
  <div id="js-business" :class="$style.business">
    <the-business-item
      v-for="(el, index) in data"
      :id="`js-business-item-${index}`"
      :key="index"
      :data="el"
      :class="activeIndex === index && 'active'"
    />
    <the-business-nav
      id="js-business-nav"
      :data="data"
      :class="$style.nav"
      @click="scrollTo"
    />
  </div>
</template>

<script>
import TheBusinessItem from './TheBusinessItem'
import TheBusinessNav from './TheBusinessNav'

export default {
  components: { TheBusinessItem, TheBusinessNav },
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      activeIndex: 0, // 当前活动区域 id
      listScenes: [],
      pinScene: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      /**
       * Add list scene
       */
      this.listScenes = this.data.map((el, index) => {
        const scene = this.$scrollmagic
          .scene({
            triggerElement:
              index === 0 ? '#js-app' : `#js-business-item-${index}`,
            triggerHook: 0.5,
            duration: this.getItemDuration(index),
          })
          .setClassToggle(`#js-business-menu-${index}`, 'active')
          .on('enter', this.handleEnter)

        // indicator
        process.env.NODE_ENV === 'development' &&
          scene.addIndicators({ name: `business ${index}` })

        this.$scrollmagic.addScene(scene)

        return scene
      })

      /**
       * Add pin scene
       */
      this.pinScene = this.$scrollmagic
        .scene({
          triggerElement: '#js-business',
          triggerHook: 0,
          duration: this.getPinDuration(),
        })
        .setPin('#js-business-nav', { pushFollowers: false })

      // indicator
      process.env.NODE_ENV === 'development' &&
        this.pinScene.addIndicators({ name: 'business pin' })

      this.$scrollmagic.addScene(this.pinScene)

      // 当窗口尺寸发生变化时重置 scene
      window.addEventListener('resize', this.resetScene)
    })
  },
  destroyed() {
    /**
     * Destroy feature scene
     */
    if (this.listScenes.length > 0) {
      this.listScenes.forEach((el) => {
        el.destroy(true)
      })
    }

    /**
     * Destroy pin scene
     */
    this.pinScene && this.pinScene.destroy(true)

    // remove resize
    window.removeEventListener('resize', this.resetScene)
  },
  methods: {
    handleEnter(event) {
      const id = event.target.triggerElement().id
      this.activeIndex = Number(id.split('-')[3]) || 0
    },
    scrollTo(index) {
      if (index !== this.activeIndex) {
        const el = document.getElementById(`js-business-item-${index}`)
        const screenHeight = window.screen.availHeight
        this.$scrollmagic.scrollTo(
          this.getOffsetTop(el) - (screenHeight - el.clientHeight) / 2
        )
      }
    },
    // 获取相对于文档最上方的高度差
    getOffsetTop(el) {
      return el.offsetParent
        ? el.offsetTop + this.getOffsetTop(el.offsetParent)
        : el.offsetTop
    },
    // 动态获取 feature duration
    getItemDuration(index) {
      const el = document.getElementById(`js-business-item-${index}`)
      const height = el.clientHeight
      return index === 0 // 列表第一条数据从文档顶部开始
        ? height + this.getOffsetTop(el)
        : // 最后一条数据到文档底部结束
        index === this.data.length - 1
        ? 0
        : height
    },
    // 动态获取 pin duration
    getPinDuration() {
      return (
        document.getElementById('js-business').clientHeight -
        document.getElementById('js-business-nav').clientHeight -
        150
      )
    },
    resetScene() {
      // 重置 list scene
      if (this.listScenes.length > 0) {
        this.listScenes.forEach((el, index) => {
          el.duration(this.getItemDuration(index))
        })
      }

      // 重置 pin scene
      if (this.pinScene) {
        this.pinScene.removePin(true)
        this.pinScene.duration(this.getPinDuration())
        this.pinScene.setPin('#js-business-nav', { pushFollowers: false })
      }
    },
  },
}
</script>

<style lang="less" module>
.business {
  position: relative;
  padding: @padding-base 0;
}

@media screen and (max-width: @mini-width) {
  .nav {
    display: none;
  }
}
</style>
